import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import login from '@/utils/login/Logins'

NProgress.configure({ showSpinner: false })

router.beforeEach((to, from, next) => {
    NProgress.start()
    if (getToken()) {
        if (!store.getters.userId){
            store.dispatch('user/getInfo').then(()=>{
                next({ ...to, replace: true })
            }).catch(()=>{
                store.dispatch('user/logout').then(err => {
                    Message.error(err)
                    next({ path: '/' })
                })
            })
        }else{
            next()
        }
    }else{
        if(to.path==='/learning-center'){
            NProgress.done()
            login.install()
            next(false);
        }else{
            next()
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})